import { Dispatch } from "redux";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { ServiceTemplateDetails } from "@idw-types/data/service-template-details/service-template-details";
import { getServiceTemplateDetailsRequest } from "@requests/management-console/get-service-template-details";
import { setServiceTemplateDetailsLoading } from "@redux/actions/service-template-details-actions";

export const getServiceTemplateDetailsReduxRequest = (dispatch: Dispatch) => async (
    serviceTemplateId: string,
    serviceTemplateNotFoundCallback: () => void
): Promise<ServiceTemplateDetails> => {
    dispatch(setServiceTemplateDetailsLoading(true));
    const { data, error } = await getServiceTemplateDetailsRequest(serviceTemplateId);

    if (data) {
        return data;
    } else {
        if (error) {
            const errorCode = JSON.parse(error).code;
            if (errorCode === 404) {
                serviceTemplateNotFoundCallback();
            } else {
                logAndDisplayErrorModal(
                    dispatch,
                    error,
                    resources.requests.getServiceTemplateDetails.error.title,
                    resources.requests.getServiceTemplateDetails.error.message,
                    error
                );
            }
        }
        dispatch(setServiceTemplateDetailsLoading(false));
        return null;
    }
};